/* cancellato UNIFORM — unico file di comportamento. Vanilla, nessuna dipendenza. */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  // Il prezzo si formatta come lo formatta il negozio (snippets/js-bridge.liquid):
  // e' il segnaposto dentro money_format a dire quali separatori usare, non la
  // lingua della pagina.
  const money = (cents) => {
    const format = window.theme?.moneyFormat || '€{{amount_with_comma_separator}}';
    const token = (format.match(/\{\{\s*([a-z_]+)\s*\}\}/i) || [])[1] || 'amount';
    const comma = token.includes('comma_separator');
    const noDecimals = token.includes('no_decimals');
    const n = cents / 100;
    let out = noDecimals
      ? String(Math.round(n))
      : n.toFixed(2);
    const [whole, dec] = out.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    out = dec ? grouped + (comma ? ',' : '.') + dec : grouped;
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/i, out);
  };

  /* ---------- drawer del menu ----------
     Due tempi: is-open mette il pannello in pagina (trasparente), is-shown al
     frame dopo fa entrare il vetro e le voci in cascata. In chiusura i ritardi
     si azzerano da soli (stanno solo sullo stato aperto) e il pannello esce
     con una dissolvenza corta prima di sparire dal flusso. */
  const drawer = () => {
    const panel = $('[data-drawer]');
    if (!panel) return;
    let hideTimer;
    const open = () => {
      clearTimeout(hideTimer);
      panel.classList.add('is-open');
      requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('is-shown')));
      document.body.classList.add('drawer-open');
      panel.querySelector('a, button')?.focus();
    };
    const close = () => {
      panel.classList.remove('is-shown');
      document.body.classList.remove('drawer-open');
      hideTimer = setTimeout(() => {
        if (!panel.classList.contains('is-shown')) panel.classList.remove('is-open');
      }, 240);
    };
    $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  };

  /* ---------- marquee ----------
     Velocita' identica al tema precedente. Li' la durata era
       (20 + 400 - speed) / 20  moltiplicata per  larghezza/1024  e per  totale/larghezza,
     dove la larghezza della finestra si semplifica: ne esce una velocita' costante di
     512 / quel-numero pixel al secondo (con speed 180 sono circa 43 px/s). */
  const marquee = () => {
    $$('[data-marquee]').forEach((el) => {
      const track = $('.scrolling-text__track', el);
      const item = $('[data-marquee-item]', track);
      if (!track || !item) return;
      const speed = Number(el.dataset.speed || 180);
      const base = Math.max(0.5, (20 + 400 - speed) / 2 / 10);
      const pxPerSecond = 512 / base;

      const build = () => {
        track.style.animation = 'none';
        [...track.children].slice(1).forEach((n) => n.remove());
        const unit = item.getBoundingClientRect().width;
        if (!unit) return;
        // una serie larga almeno quanto la sezione, poi duplicata per il ciclo
        const perSeries = el.dataset.repeat === 'false' ? 1 : Math.ceil(el.offsetWidth / unit) + 1;
        const series = document.createDocumentFragment();
        for (let i = 1; i < perSeries; i++) {
          const c = item.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          series.appendChild(c);
        }
        track.appendChild(series);
        [...track.children].forEach((n) => {
          const c = n.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        });
        track.style.animation = '';
        // l'animazione trasla di meta' traccia: la durata e' quella meta' divisa la velocita'
        track.style.setProperty('--scroll-duration', `${Math.max(1, (unit * perSeries) / pxPerSecond)}s`);
      };

      build();
      let t;
      new ResizeObserver(() => {
        clearTimeout(t);
        t = setTimeout(build, 150);
      }).observe(el);
    });
  };

  /* ---------- logo fisso: compare sul footer, come prima ---------- */
  const fixedLogo = () => {
    const logo = $('.fixed-logo');
    if (!logo) return;
    const isHome = location.pathname === '/' || location.pathname === '/pages/home-preview';
    if (isHome) {
      logo.classList.add('is-visible');
      return;
    }
    const footer = $('footer');
    if (!footer) return;
    new IntersectionObserver(
      ([entry]) => logo.classList.toggle('is-visible', entry.isIntersecting),
      { rootMargin: '0px' }
    ).observe(footer);
  };

  /* ---------- selettore di quantita' ---------- */
  const quantity = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      const input = $('input', btn.parentElement);
      if (!input) return;
      const step = btn.dataset.qty === 'up' ? 1 : -1;
      input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  /* ---------- pagina prodotto: varianti ---------- */
  const productForm = () => {
    $$('[data-product]').forEach((root) => {
      const data = JSON.parse($('[data-product-json]', root)?.textContent || 'null');
      if (!data) return;
      const form = $('form[action*="/cart/add"]', root);
      const idInput = $('[name="id"]', form);
      const priceEl = $('[data-price]', root);
      const compareEl = $('[data-compare-price]', root);
      const atc = $('[data-atc]', root);
      const selected = new Map();

      $$('[data-option-value]', root).forEach((b) => {
        if (b.getAttribute('aria-pressed') === 'true') selected.set(b.dataset.optionIndex, b.dataset.optionValue);
      });

      const findVariant = () =>
        data.variants.find((v) =>
          [...selected.entries()].every(([i, val]) => v.options[Number(i)] === val)
        );

      const refresh = () => {
        const variant = findVariant();

        // Stato di ogni valore rispetto alla selezione corrente: esaurito (esiste ma
        // non disponibile) oppure inesistente (combinazione che non c'e' a catalogo).
        $$('[data-option-value]', root).forEach((b) => {
          const probe = new Map(selected);
          probe.set(b.dataset.optionIndex, b.dataset.optionValue);
          const match = data.variants.find((v) =>
            [...probe.entries()].every(([i, val]) => v.options[Number(i)] === val)
          );
          b.dataset.available = String(Boolean(match && match.available));
          const cell = b.closest('.option__cell');
          if (cell) {
            cell.dataset.optionState = !match ? 'unavailable' : match.available ? 'available' : 'sold-out';
          }
        });

        if (!variant) {
          atc && (atc.disabled = true);
          return;
        }
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        const qbPrice = $('[data-quickbar-price]', root);
        if (qbPrice) qbPrice.textContent = money(variant.price);
        if (compareEl) {
          const show = variant.compare_at_price > variant.price;
          compareEl.hidden = !show;
          if (show) compareEl.textContent = money(variant.compare_at_price);
        }
        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available
            ? atc.dataset.labelAdd || window.theme?.strings?.addToCart || 'Add to cart'
            : atc.dataset.labelSoldOut || window.theme?.strings?.soldOut || 'Sold out';
        }
        // immagine della variante
        const media = variant.featured_media?.id && $(`[data-media-id="${variant.featured_media.id}"]`, root);
        media?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      };

      $$('[data-option-value]', root).forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = btn.dataset.optionIndex;
          $$(`[data-option-value][data-option-index="${idx}"]`, root).forEach((b) =>
            b.setAttribute('aria-pressed', String(b === btn))
          );
          selected.set(idx, btn.dataset.optionValue);
          refresh();
        });
      });

      refresh();
    });
  };

  /* ---------- filtri della collezione ---------- */
  const filters = () => {
    $$('[data-filter-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const list = btn.nextElementSibling;
        const open = !list.hidden;
        $$('[data-filter-toggle] + *').forEach((l) => (l.hidden = true));
        list.hidden = open;
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.filter')) $$('.filter__list').forEach((l) => (l.hidden = true));
    });
    // invio automatico: niente pulsante "applica". Prima di inviare, le caselle
    // speculari (il tag refuso "Sprint Summer" assorbito da "Spring Summer")
    // si allineano alla loro casella visibile.
    $$('[data-filter-form]').forEach((form) => {
      form.addEventListener('change', () => {
        $$('[data-filter-master]', form).forEach((m) => {
          const mirror = m.parentElement.querySelector('[data-filter-mirror]');
          if (mirror) mirror.checked = m.checked;
        });
        form.submit();
      });
    });
  };

  /* ---------- fogli: cookie, eta', promo ---------- */
  const sheets = () => {
    $$('[data-sheet]').forEach((sheet) => {
      const key = `cu:${sheet.dataset.sheet}`;
      const delay = Number(sheet.dataset.delay || 0);
      if (localStorage.getItem(key) === 'done') return;
      setTimeout(() => (sheet.hidden = false), delay);
      $$('[data-sheet-dismiss]', sheet).forEach((b) =>
        b.addEventListener('click', () => {
          sheet.hidden = true;
          localStorage.setItem(key, 'done');
        })
      );
    });
  };

  /* ---------- video in autoplay solo quando si vedono ---------- */
  const lazyVideo = () => {
    const vids = $$('video[data-autoplay]');
    if (!vids.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.play().catch(() => {});
        else e.target.pause();
      });
    });
    vids.forEach((v) => io.observe(v));
  };

  /* ---------- ricerca predittiva ---------- */
  const search = () => {
    const form = $('[data-predictive-search]');
    if (!form) return;
    const input = $('input[type="search"]', form);
    const results = $('[data-search-results]', form);
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        return;
      }
      t = setTimeout(async () => {
        const res = await fetch(
          `${window.theme?.routes?.predictiveSearch || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=6&section_id=predictive-search`
        );
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        results.innerHTML = doc.querySelector('[data-search-results]')?.innerHTML || '';
      }, 220);
    });
  };

  /* ---------- scheda prodotto: striscia delle foto su mobile ----------
     I pallini sono link veri e funzionano anche senza JS; qui si aggiunge lo
     scorrimento morbido, le frecce e il pallino attivo. */
  const productMediaNav = () => {
    $$('[data-media-nav]').forEach((nav) => {
      const strip = nav.parentElement.querySelector('[data-media-strip]');
      if (!strip) return;
      const items = [...strip.children];
      const dots = $$('[data-media-dot]', nav);
      // le foto possono avere larghezze diverse (le orizzontali sbordano):
      // l'indice si trova dagli offset, non dividendo per la larghezza della finestra
      const current = () => {
        let i = 0;
        items.forEach((el, k) => {
          if (el.offsetLeft <= strip.scrollLeft + 1) i = k;
        });
        return i;
      };
      const goTo = (i) => {
        const n = Math.max(0, Math.min(items.length - 1, i));
        strip.scrollTo({ left: items[n].offsetLeft, behavior: 'smooth' });
      };
      const sync = () =>
        dots.forEach((d, i) =>
          i === current() ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')
        );

      dots.forEach((d, i) =>
        d.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(i);
        })
      );
      $$('[data-media-step]', nav).forEach((b) =>
        b.addEventListener('click', () => goTo(current() + Number(b.dataset.mediaStep)))
      );
      strip.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      sync();
      nav.dataset.mediaReady = '';
    });
  };

  /* ---------- commerce ---------- */
  /* cancellato UNIFORM — comportamenti del gruppo commerce.
     Funzioni autonome, da chiamare dentro init() di assets/theme.js.
     Niente dipendenze, niente listener globali duplicati. */

  /* --- etichetta dell'opzione selezionata -------------------------------------
     Il tema precedente scriveva "Colours: Black" accanto ai campioni colore.
     theme.js gestisce gia' il click sui bottoni [data-option-value]: qui si
     aggiorna solo il testo di [data-option-selected] con lo stesso indice. */
  let optionLabelsBound = false;
  const optionLabels = () => {
    if (optionLabelsBound) return;
    optionLabelsBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      const root = btn.closest('[data-product]');
      const label = root?.querySelector(
        `[data-option-selected][data-option-index="${btn.dataset.optionIndex}"]`
      );
      if (label) label.textContent = btn.dataset.optionValue;
    });
  };

  /* --- carrello: aggiornamento senza ricaricare a mano -------------------------
     Senza JS resta il pulsante "Aggiorna"; con JS la riga si aggiorna da sola
     poco dopo la modifica della quantita'. */
  const cartAutoUpdate = () => {
    const form = document.getElementById('cart');
    if (!form) return;
    let t;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => form.submit(), 600);
    });
  };

  /* --- prodotti correlati -----------------------------------------------------
     La sezione arriva gia' piena dal server (prodotti della stessa raccolta).
     Se Shopify ha raccomandazioni vere, si sostituisce la riga a pagina carica. */
  const relatedProducts = () => {
    const section = document.querySelector('[data-recommendations-url]');
    if (!section) return;
    fetch(section.dataset.recommendationsUrl)
      .then((res) => (res.ok ? res.text() : null))
      .then((html) => {
        if (!html) return;
        const grid = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.related-products .product-grid');
        const current = section.querySelector('.product-grid');
        if (grid && current && grid.children.length) current.replaceWith(grid);
      })
      .catch(() => {});
  };

  /* --- banner privacy ---------------------------------------------------------
     I pulsanti chiudono il foglio tramite theme.js; qui si registra il consenso
     nell'API di Shopify quando e' disponibile. */
  let privacyConsentBound = false;
  const privacyConsent = () => {
    if (privacyConsentBound) return;
    privacyConsentBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-privacy]');
      if (!btn) return;
      const granted = btn.dataset.privacy === 'accept';
      window.Shopify?.customerPrivacy?.setTrackingConsent(
        {
          analytics: granted,
          marketing: granted,
          preferences: granted,
          sale_of_data: granted,
        },
        () => {}
      );
    });
  };

  /* --- verifica dell'eta' ----------------------------------------------------- */
  const ageCheck = () => {
    const sheet = document.querySelector('[data-sheet="age"]');
    if (!sheet) return;
    const redirect = () => {
      window.location.href = sheet.dataset.ageRedirect || 'https://www.google.com';
    };

    sheet.querySelector('[data-age-deny]')?.addEventListener('click', redirect);

    const form = sheet.querySelector('[data-age-form]');
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const read = (name) => Number(form.querySelector(`[data-age-${name}]`)?.value);
      const birth = new Date(read('year'), read('month') - 1, read('day'));
      if (Number.isNaN(birth.getTime())) return;

      const minimum = Number(sheet.dataset.ageMinimum || 18);
      const limit = new Date();
      limit.setFullYear(limit.getFullYear() - minimum);

      if (birth <= limit) {
        sheet.hidden = true;
        localStorage.setItem('cu:age', 'done');
      } else {
        redirect();
      }
    });
  };

  /* Da incollare dentro l'IIFE di assets/theme.js e chiamare in init():
     optionLabels();
    productMediaNav();
    dialogs();
    productSizeGuide(); cartAutoUpdate(); relatedProducts(); privacyConsent(); ageCheck();
     Nessun export: theme.js non e' un modulo. */

  /* ---------- immagini a pila: velo sull'ultima mentre esce ---------- */
  let stackBound = false;
  const stickyStack = () => {
    const stacks = $$('[data-sticky-stack]');
    if (!stacks.length || stackBound) return;
    stackBound = true;

    let queued = false;
    const update = () => {
      queued = false;
      stacks.forEach((stack) => {
        const veil = $('[data-sticky-veil]', stack);
        if (!veil) return;
        const vh = window.innerHeight || 1;
        // l'ultima immagine resta incollata finche' la pila non esce: il velo
        // la schiarisce in quell'ultima schermata di scorrimento
        const left = stack.getBoundingClientRect().bottom;
        const p = Math.min(1, Math.max(0, (vh - left) / vh));
        veil.style.setProperty('--veil', p.toFixed(3));
      });
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  };

  /* ---------- pannello con le foto nella barra ("World") ---------- */
  /* Si apre al click come sul sito live, non in hover: il pannello e' alto
     quanto mezza pagina e in hover scatterebbe passandoci sopra. */
  let featureDocBound = false;
  const headerFeature = () => {
    const groups = $$('[data-header-feature]');
    if (!groups.length) return;

    const close = (group) => {
      group.removeAttribute('data-open');
      $('[data-header-feature-toggle]', group)?.setAttribute('aria-expanded', 'false');
    };
    const closeAll = () => groups.forEach(close);

    groups.forEach((group) => {
      if (group.dataset.featureBound) return;
      group.dataset.featureBound = '1';
      const toggle = $('[data-header-feature-toggle]', group);
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const open = group.hasAttribute('data-open');
        closeAll();
        if (open) return;
        group.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      });

      // uscendo dal pannello con Tab il pannello si chiude, non resta aperto a vuoto
      group.addEventListener('focusout', (e) => {
        if (!group.contains(e.relatedTarget)) close(group);
      });
    });

    if (featureDocBound) return;
    featureDocBound = true;

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = $$('[data-header-feature][data-open]');
      if (!open.length) return;
      open.forEach((group) => {
        close(group);
        $('[data-header-feature-toggle]', group)?.focus();
      });
    });

    document.addEventListener('click', (e) => {
      $$('[data-header-feature][data-open]').forEach((group) => {
        if (!group.contains(e.target)) close(group);
      });
    });
  };

  /* ---------- guida taglie in finestra ---------- */
  /* Guida taglie in finestra.
     Il richiamo nel testo resta un link vero: senza JavaScript, con il tasto
     centrale o con cmd/ctrl-clic porta alla pagina come sempre. Col JavaScript
     il clic apre il <dialog> e, solo al primo clic, chiede la pagina indicata in
     `data-sheet-src` e ne travasa le sezioni elencate in `data-sheet-sections`
     (quella pagina non ha un corpo di testo, e' costruita a sezioni). Se la
     richiesta non riesce si segue il link, cosi' l'informazione non si perde.
     Da integrare nell'IIFE di theme.js: productSizeGuide(). */
  function productSizeGuide() {
    const triggers = document.querySelectorAll('[data-sheet-load]');
    if (!triggers.length) return;

    const done = new WeakSet();
    const running = new WeakMap();

    // le sezioni richieste, nell'ordine in cui stanno nella pagina.
    // Solo i contenitori di sezione: dentro ci sono elementi con id simile
    // (il div del rich text) che altrimenti arriverebbero una seconda volta.
    const collect = (doc, types) => {
      const root = doc.querySelector('main') || doc.body;
      const found = [];
      types.forEach((type) => {
        root
          .querySelectorAll(`[id^="shopify-section-"][id*="__${type}"]`)
          .forEach((el) => {
            if (!found.includes(el)) found.push(el);
          });
      });
      return found.sort((a, b) =>
        a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
    };

    const load = (dialog) => {
      if (done.has(dialog)) return Promise.resolve(true);
      if (running.has(dialog)) return running.get(dialog);

      const body = dialog.querySelector('[data-sheet-body]');
      const types = (dialog.dataset.sheetSections || '')
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);

      const job = fetch(dialog.dataset.sheetSrc, { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.text() : Promise.reject(new Error(res.status))))
        .then((html) => {
          const parts = collect(new DOMParser().parseFromString(html, 'text/html'), types);
          if (!parts.length) throw new Error('nessuna sezione utile');
          body.replaceChildren(
            ...parts.map((el) => {
              const copy = document.importNode(el, true);
              // in una guida taglie le fasce devono leggersi subito
              copy.querySelectorAll('details').forEach((d) => {
                d.open = true;
              });
              return copy;
            })
          );
          body.dataset.sheetLoaded = '';
          done.add(dialog);
          return true;
        })
        .catch(() => false)
        .finally(() => {
          dialog.removeAttribute('aria-busy');
          running.delete(dialog);
        });

      running.set(dialog, job);
      return job;
    };

    triggers.forEach((trigger) => {
      const dialog = document.getElementById(trigger.dataset.sheetLoad);
      if (!dialog || typeof dialog.showModal !== 'function') return;

      trigger.addEventListener('click', (event) => {
        // i clic che il browser apre altrove restano del browser
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        if (!done.has(dialog)) dialog.setAttribute('aria-busy', 'true');
        dialog.showModal();

        load(dialog).then((ok) => {
          if (ok || !dialog.open) return;
          dialog.close();
          window.location.href = trigger.href;
        });
      });

      // il contenuto si chiede appena la pagina e' tranquilla, non al primo
      // clic: la finestra si apre gia' piena, senza stato di caricamento
      const prefetch = () => load(dialog);
      if ('requestIdleCallback' in window) requestIdleCallback(prefetch, { timeout: 4000 });
      else setTimeout(prefetch, 1500);
    });
  }

  /* ---------- immagini: scaldare le pigre prima che arrivino a schermo ----------
     Le immagini fuori schermo restano lazy per il primo render, ma appena la
     pagina ha caricato si chiedono in anticipo: nella striscia della scheda
     prodotto tutte (lo swipe le deve trovare pronte), altrove quando mancano
     tre schermate. Cosi' non si vede mai il riquadro vuoto. */
  let warmBound = false;
  const warmImages = () => {
    if (warmBound) return;
    warmBound = true;

    const eager = (img) => {
      if (!img || img.dataset.warmed) return;
      img.dataset.warmed = '1';
      img.loading = 'eager';
      if (!img.complete) img.decode?.().catch(() => {});
    };

    const start = () => {
      // striscia della scheda prodotto: poche immagini, tutte subito
      $$('[data-media-strip] img[loading="lazy"]').forEach(eager);

      const rest = $$('img[loading="lazy"]').filter((i) => !i.dataset.warmed);
      if (!rest.length) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            eager(e.target);
          });
        },
        { rootMargin: '300% 0px 300% 0px' }
      );
      rest.forEach((i) => io.observe(i));
    };

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  };

  /* ---------- scheda prodotto: pannello informazioni su mobile ----------
     Sotto i 1024px il pannello e' fisso in basso (vetro chiaro, scroll interno)
     e le foto scorrono sopra: l'altezza reale finisce in --panel-h, che tiene
     la striscia e i pallini sopra il pannello. */
  /* ---------- scheda prodotto mobile: barretta ADD + prezzo ----------
     Mentre si scorrono le foto la barretta di vetro resta a vista; quando il
     blocco informazioni vero entra in schermo, la barretta scivola via. ADD
     invia il form del prodotto (variante selezionata), che apre il carrello. */
  const pdpPanel = () => {
    const root = $('[data-product]');
    const bar = $('[data-quickbar]');
    if (!root || !bar) return;
    const info = $('.product__info', root);
    const form = $('form[action*="/cart/add"]', root);

    new IntersectionObserver(
      ([entry]) => {
        if (window.innerWidth >= 1024) return;
        if (entry.isIntersecting) bar.setAttribute('data-away', '');
        else bar.removeAttribute('data-away');
      },
      { rootMargin: '0px 0px -20% 0px' }
    ).observe(info);

    $('[data-quickbar-add]', bar)?.addEventListener('click', () => {
      if (form) form.requestSubmit();
    });
  };

  /* ---------- filtri: la colonna centrale parte dove parte la nav ----------
     Il pannello dei filtri allinea la seconda colonna all'attacco di "Shop"
     nell'header: la nav e' un blocco centrato, quindi la posizione si misura
     e finisce in --nav-left, che il CSS usa come larghezza della prima corsia. */
  const filterNavAlign = () => {
    if (!$('.filter__groups')) return;
    const shopLink = $$('.header a').find((a) => /^shop$/i.test(a.textContent.trim()));
    if (!shopLink) return;
    const apply = () =>
      document.documentElement.style.setProperty('--nav-left', `${Math.round(shopLink.getBoundingClientRect().left)}px`);
    apply();
    window.addEventListener('resize', apply);
  };

  /* ---------- carrello a pannello (vetro chiaro) ----------
     Il link del carrello e l'aggiunta dal prodotto aprono il pannello;
     le righe si ricostruiscono da /cart.js, quantita' e rimozione passano da
     /cart/change.js. Senza JavaScript tutto resta com'era: link alla pagina
     /cart e form che naviga. */
  const cartDrawer = () => {
    const drawer = $('[data-cart-drawer]');
    if (!drawer || drawer.dataset.bound) return;
    drawer.dataset.bound = '1';

    const panel = $('.cart-drawer__panel', drawer);
    const lines = $('[data-cart-lines]', drawer);
    const emptyMsg = $('[data-cart-empty]', drawer);
    const foot = $('[data-cart-foot]', drawer);
    const subtotal = $('[data-cart-subtotal]', drawer);

    const open = () => {
      drawer.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
      document.body.classList.add('cart-open');
      $('.cart-drawer__close', drawer)?.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('cart-open');
      // il pannello fermo va tolto dal flusso (gotcha dei fixed su iOS)
      setTimeout(() => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 380);
    };

    $$('[data-cart-close]', drawer).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    $$('[data-cart-open]').forEach((a) =>
      a.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        open();
      })
    );

    const el = (tag, cls, text) => {
      const n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    };

    const buildLine = (item) => {
      const li = el('li', 'cart-drawer__line');
      li.dataset.key = item.key;

      const media = el('a', 'cart-drawer__media');
      media.href = item.url;
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const img = el('img');
        img.src = `${item.image}${item.image.includes('?') ? '&' : '?'}width=240`;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const info = el('div', 'cart-drawer__info');
      const title = el('a', null, item.product_title);
      title.href = item.url;
      info.appendChild(title);
      if (item.variant_title) info.appendChild(el('p', 'cart-drawer__meta', item.variant_title));

      const qty = el('div', 'qty qty--small');
      const down = el('button', null, '−');
      down.type = 'button';
      down.dataset.qty = 'down';
      const input = el('input');
      input.type = 'number';
      input.value = item.quantity;
      input.min = '0';
      input.step = '1';
      input.inputMode = 'numeric';
      input.dataset.cartQty = '';
      const up = el('button', null, '+');
      up.type = 'button';
      up.dataset.qty = 'up';
      qty.append(down, input, up);
      info.appendChild(qty);

      const end = el('div', 'cart-drawer__end');
      end.appendChild(el('span', 'cart-drawer__price', money(item.final_line_price)));
      const remove = el('button', 'cart-drawer__remove', window.theme?.strings?.remove || 'Remove');
      remove.type = 'button';
      remove.dataset.cartRemove = '';
      end.appendChild(remove);

      li.append(media, info, end);
      return li;
    };

    const render = (cart) => {
      lines.replaceChildren(...cart.items.map(buildLine));
      $$('[data-cart-count]').forEach((n) => (n.textContent = cart.item_count));
      if (subtotal) subtotal.textContent = money(cart.total_price);
      const isEmpty = cart.item_count === 0;
      emptyMsg.hidden = !isEmpty;
      foot.hidden = isEmpty;
    };

    const refresh = () =>
      fetch('/cart.js', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then(render);

    const change = (key, quantity) =>
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      })
        .then((r) => (r.ok ? r.json() : refresh().then(() => null)))
        .then((cart) => cart && render(cart));

    // quantita' e rimozione dentro al pannello
    lines.addEventListener('change', (e) => {
      if (!e.target.matches('[data-cart-qty]')) return;
      const key = e.target.closest('[data-key]')?.dataset.key;
      if (key) change(key, Math.max(0, Number(e.target.value || 0)));
    });
    lines.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      const key = btn.closest('[data-key]')?.dataset.key;
      if (key) change(key, 0);
    });

    // l'aggiunta al carrello apre il pannello invece di cambiare pagina;
    // se la richiesta fallisce (es. esaurito nel frattempo) si torna al form
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const atc = form.querySelector('[data-atc]');
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          return refresh();
        })
        .then(open)
        .catch(() => {
          if (atc) {
            atc.textContent = window.theme?.strings?.cartAddError || 'Unable to add — retry';
            setTimeout(() => {
              atc.textContent = atc.dataset.labelAdd || 'Add to cart';
            }, 2500);
          }
        });
    });
  };

  /* ---------- finestre: ripiego per i browser senza "command" ---------- */
  const dialogs = () => {
    if ('command' in HTMLButtonElement.prototype) return;
    $$('[commandfor]').forEach((b) =>
      b.addEventListener('click', () => document.getElementById(b.getAttribute('commandfor'))?.showModal())
    );
  };

  const init = () => {
    drawer();
    headerFeature();
    marquee();
    stickyStack();
    fixedLogo();
    quantity();
    productForm();
    filters();
    sheets();
    lazyVideo();
    search();
    optionLabels();
    productMediaNav();
    pdpPanel();
    warmImages();
    filterNavAlign();
    cartDrawer();
    dialogs();
    productSizeGuide();
    cartAutoUpdate();
    relatedProducts();
    privacyConsent();
    ageCheck();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // il theme editor ricarica pezzi di pagina: ricollega i comportamenti
  document.addEventListener('shopify:section:load', init);
})();
